import {sendEmailVerification} from "firebase/auth";

export const VERIFICATION_RESEND_COOLDOWN_MS = 60_000;
const STORAGE_KEY = "vtk-email-verification-last-sent";

export function verificationActionSettings(origin = window.location.origin) {
  const parsed = new URL(origin);
  const loopback = parsed.hostname === "localhost" || parsed.hostname === "127.0.0.1";
  if ((!loopback && parsed.protocol !== "https:") || (loopback && !["http:", "https:"].includes(parsed.protocol))) {
    throw new Error("Email verification return URL is invalid.");
  }
  return {url: new URL("/beatmatch-beta", parsed.origin).href, handleCodeInApp: false};
}

function usableStorage(storage) {
  return storage && typeof storage.getItem === "function" && typeof storage.setItem === "function" ? storage : null;
}

export async function sendCustomerVerificationEmail(user, {
  nowMs = Date.now(), storage = typeof window === "undefined" ? null : window.sessionStorage,
  origin = typeof window === "undefined" ? "https://vonthekeyz.com" : window.location.origin,
  sender = sendEmailVerification,
} = {}) {
  if (!user || user.isAnonymous || !user.email) throw new Error("Sign in with an email account first.");
  if (user.emailVerified) return {alreadyVerified: true, sent: false, retryAtMs: nowMs};
  const local = usableStorage(storage); const previous = Number(local?.getItem(STORAGE_KEY) || 0);
  const retryAtMs = previous + VERIFICATION_RESEND_COOLDOWN_MS;
  if (Number.isFinite(previous) && previous > 0 && retryAtMs > nowMs) {
    const error = new Error("Please wait before requesting another verification email.");
    error.code = "verification-resend-rate-limited"; error.retryAtMs = retryAtMs; throw error;
  }
  await sender(user, verificationActionSettings(origin));
  local?.setItem(STORAGE_KEY, String(nowMs));
  return {alreadyVerified: false, sent: true, retryAtMs: nowMs + VERIFICATION_RESEND_COOLDOWN_MS};
}

export async function refreshCustomerVerification(user) {
  if (!user || user.isAnonymous) throw new Error("Sign in with an email account first.");
  await user.reload();
  await user.getIdToken(true);
  return user.emailVerified === true;
}
